<template>
  <div :class="componentClassName">
    <a-page-heading>アカウント情報確認・変更</a-page-heading>

    <m-section>
      <m-action-card title="ユーザー情報編集" icon="user" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-profile-edit-user-info__form" @submit.prevent="handleFormSubmit">
          <div v-if="userInfo" class="t-profile-edit-user-info__fields">
            <m-form-input label="ユーザーID">
              <a-text-field
                id="userIdTextField"
                v-model="userData.userID"
                maxlength="50"
                type="text"
                :disabled="userData.authInfo === 'supervisor'"
              />
            </m-form-input>
            <m-form-input label="登録名">
              <a-text-field id="screenNameTextField" v-model="userData.username" type="text" />
            </m-form-input>
            <m-form-input label="部署名（任意）">
              <a-text-field id="departmentTextField" v-model="userData.departmentInfo" type="text" />
            </m-form-input>
          </div>
          <m-form-action-buttons class="t-profile-edit-user-info__buttons">
            <a-button v-if="userInfo" id="profileSaveButton" variant="block" color="primary" @click="handleUserEdit"
              >保存</a-button
            >
            <a-button id="profileSaveCancelButton" variant="outlined" color="primary" @click="handleCancelClick"
              >キャンセル</a-button
            >
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="profileEditUserInfo_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          v-if="!isUpdateEmail"
          id="profileModalCloseButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          v-if="isUpdateEmail"
          id="profileModalCloseButton"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          v-if="isUpdateEmail"
          id="profileModalCloseButton"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleForceUpdateEmail"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { mapActions } from 'vuex';

export default {
  name: 't-profile-edit-user-info',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ATextField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    //userInfo: {
    //  type: Object,
    //  required: true,
    //},
    //handleCancelClick: {
    //  type: Function,
    //  default: () => {},
    //},
    //handleUserEdit: {
    //  type: Function,
    //  default: data => {},
    //},
  },
  //data() {
  //  return {
  //    userData: {
  //      email: '',
  //      name: '',
  //      department: '',
  //    },
  //  };
  //},
  data() {
    return {
      userData: {
        userID: '',
        companyID: '',
        username: '',
        departmentInfo: '',
        authInfo: '',
        group: '',
        clientName: '',
        phone_number: '',
      },
      userInfo: {},
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      forceUpdateEmail: false,
      forceLoggout: false,
      isUpdateEmail: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-profile-edit-user-info');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    const companyID = this.$route.query.companyID;
    const userID = this.$route.query.userID;
    if (userID) {
      this.postRequest('/idmgmt/getuserdata', { companyID: companyID, userID: userID })
        .then(e => {
          if (e.status === 'success') {
            this.userData = e.data;
            this.userData.userID = userID;
            this.userData.username = this.userData.username.replace('_', ' ');
            Object.assign(this.userInfo, this.userData);
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    }
  },
  methods: {
    ...mapActions(['updateLoginInfo']),
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleUserEdit(cloneDeep(this.userData));
    },
    handleUserEdit() {
      if (this.hasSpecialCharacterInObject(this.userData)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      } else if (!this.addressCheck(this.userData.userID)) {
        this.showErrorModal(messageContent.userInfoEmailError);
        return;
      }
      const userIDLengthCheck = this.emailLengthCheck(this.userData.userID);
      if (!userIDLengthCheck.status) {
        this.showErrorModal(userIDLengthCheck.message);
        return;
      }
      if (!this.userData.username) {
        this.showErrorModal(messageContent.userInfoUsernameError);
        return;
      }
      const lengthCheck = this.departmentNameLengthCheck(this.userData.departmentInfo);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      // Underbar check for username
      const underbarCheck = this.fullnameUnderbarCheck(this.userData.username, '登録名');
      if (!underbarCheck.status) {
        this.showErrorModal(underbarCheck.message);
        return;
      }
      // Only space check
      let onlySpaceChk = this.onlySpaceCheck(this.userData.username, '登録名');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }
      onlySpaceChk = this.onlySpaceCheck(this.userData.departmentInfo, '部署名');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }

      if (this.userData.userID !== this.$route.query.userID && !this.forceUpdateEmail) {
        this.isUpdateEmail = true;
        this.showConfirmModal(messageContent.confirmForceUpdateUserID(this.userData.userID));
        return;
      }

      const sendData = {
        username: this.userData.username,
        authInfo: this.userData.authInfo,
        departmentInfo: this.userData.departmentInfo,
        clientName: this.userData.clientName,
        //smsNumber: this.userData.smsNumber
      };
      const formDataTmp = {
        userID: this.userData.userID,
        companyID: this.$route.query.companyID,
        userData: sendData,
      };
      this.postRequest('/idmgmt/update-profile', formDataTmp)
        .then(e => {
          this.forceUpdateEmail = false;
          if (e.status && e.status !== 'failed') {
            if (e.status === 'validationError') return this.showErrorModal(e.msg);
            this.showInfoModal(messageContent.userInfoUpdateSuccess);
            if (e.status === 'loggedOut') {
              this.forceLoggout = true;
              return true;
            }
            this.userData.companyID = this.$route.query.companyID;
            const loginInfo = {};
            Object.assign(loginInfo, this.userData);
            // Merge processed user data with user data in the store
            // Make sure updated data also update, and un-updated fields be kept in the store
            const storeUserData = this.$store.state.user;
            for (const key in storeUserData) {
              if (typeof loginInfo[key] === 'undefined' || loginInfo[key] === null) {
                loginInfo[key] = storeUserData[key];
              }
            }
            return this.updateLoginInfo(loginInfo);
          } else {
            return this.showErrorModal(messageContent.userInfoUpdateFailed);
          }
        })
        .catch(() => {
          this.forceUpdateEmail = false;
          this.showErrorModal(messageContent.userInfoUpdateFailed);
        });
    },
    handleForceUpdateEmail() {
      this.resultModalVisible = false;
      this.forceUpdateEmail = true;
      this.isUpdateEmail = false;
      this.handleUserEdit();
    },
    handleCancelClick() {
      this.$router.push('/profilelist');
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.forceLoggout) window.location.href = '/login';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    showConfirmModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.confirmModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
